export const EHR_NETWORK_PROVIDERS = ['commonwell', 'carequality', 'tefca'];

export const DATA_PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  commonwell: 'CommonWell',
  carequality: 'Carequality',
  tefca: 'TEFCA',
  surescripts: 'Surescripts',
  quest: 'Quest',
};
